import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "container", "backdrop"]

  connect() {
    this.closeWithKeyboard = this.closeWithKeyboard.bind(this)
  }

  open() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.closeWithKeyboard)

    setTimeout(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.backdropTarget.classList.add("opacity-100")
      this.containerTarget.classList.remove("opacity-0", "scale-95")
      this.containerTarget.classList.add("opacity-100", "scale-100")
    }, 10)
  }

  close() {
    // アニメーション
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    this.containerTarget.classList.remove("opacity-100", "scale-100")
    this.containerTarget.classList.add("opacity-0", "scale-95")

    setTimeout(() => {
      this.modalTarget.classList.add("hidden")
      document.body.style.overflow = "auto"
      document.removeEventListener("keydown", this.closeWithKeyboard)
    }, 200)
  }

  closeWithKeyboard(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeBackground(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeWithKeyboard)
    document.body.style.overflow = "auto"
  }
}
